import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { FIELD_TYPE_TEXT, FIELD_TYPE_POSTAL, FIELD_TYPE_NUMERICAL, FIELD_TYPE_ADDRESS, FIELD_TYPE_CHOICE } from '../../../utils/CONSTANTS.js';
import { ApiContext, WizardContext } from '../../../utils/contexts.js';
import Default from './Default.js';
import Choice from './Choice.js';
import Address from './Address.js';
import Number from './Number.js';
import Slider from './Slider.js';
import { getStep } from '../../../services/models/dialog.js';
import { jsx } from '@emotion/react';
var _excluded = ["mandatory", "placeholder", "street_placeholder", "zipcode_placeholder", "city_placeholder", "step_size", "default", "min", "max", "unit"];
var Renderer = function Renderer(_ref) {
  var stepKey = _ref.stepKey,
    lineKey = _ref.lineKey;
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    currentStepKey = _useContext2.currentStep,
    currentLine = _useContext2.currentLine;
  var _getStep = getStep(data, currentLine, currentStepKey),
    options = _getStep.options,
    type = _getStep.type;
  var mandatory = options.mandatory,
    placeholder = options.placeholder,
    placeholderStreet = options.street_placeholder,
    placeholderZip = options.zipcode_placeholder,
    placeholderCity = options.city_placeholder,
    stepSize = options.step_size,
    defaultValue = options["default"],
    min = options.min,
    max = options.max,
    unit = options.unit,
    restOptions = _objectWithoutProperties(options, _excluded);
  switch (type) {
    case FIELD_TYPE_CHOICE:
      return jsx(Choice, {
        options: restOptions,
        mandatory: mandatory,
        stepKey: stepKey,
        lineKey: lineKey
      });
    case FIELD_TYPE_ADDRESS:
      return jsx(Address, {
        options: restOptions,
        mandatory: mandatory,
        placeholderStreet: placeholderStreet,
        placeholderZip: placeholderZip,
        placeholderCity: placeholderCity,
        stepKey: stepKey,
        lineKey: lineKey
      });
    case 'slider':
      return jsx(Slider, {
        options: restOptions,
        mandatory: mandatory,
        stepKey: stepKey,
        lineKey: lineKey,
        unit: unit,
        placeholder: placeholder,
        min: min,
        max: max,
        defaultValue: defaultValue,
        stepSize: stepSize
      });
    case FIELD_TYPE_NUMERICAL:
    case FIELD_TYPE_POSTAL:
      return jsx(Number, {
        options: restOptions,
        mandatory: mandatory,
        stepKey: stepKey,
        lineKey: lineKey,
        type: type,
        unit: unit,
        placeholder: placeholder
      });
    case FIELD_TYPE_TEXT:
      // Sadly, 'text' - in the eye of the backend - can also be number fields,
      // so that's a bit confusing.
      return jsx(Default, _extends({
        type: min || max ? 'number' : 'text',
        name: stepKey
      }, restOptions, {
        stepKey: stepKey,
        lineKey: lineKey
      }));
    default:
      return jsx(Default, _extends({
        type: "text",
        name: stepKey
      }, restOptions, {
        stepKey: stepKey,
        lineKey: lineKey
      }));
  }
};
Renderer.propTypes = {
  stepKey: PropTypes.string.isRequired,
  lineKey: PropTypes.string.isRequired
};
export { Renderer as default };